/* eslint-disable */
import axios from 'axios';

import pushEvent, {
  positionGTMEnum,
  EVENT_ADD_ACCESSORY,
  // EVENT_COMMON_ADD_TO_CART,
  EVENT_OPEN_ACCESSORY_POPUP,
  EVENT_VIEW_ACCESSORY,
} from 'pushEvent';
import { toUrlEncodedString } from 'utils/forms';
import { SET_COMMON_LOADING } from 'store/common/basket/constants';
import { redirectToBasket } from 'utils/basket';
import {
  getRequestVerificationToken,
  getCurrentFederalRegionName,
  getCurrentRegionName,
  getCookie,
  getCurrentRegionCode,
  selectIsBasketRedirectEnabled,
} from 'store/common/settings/selectors';
import { toggleCompareProduct } from 'store/common/compare/actions';
import { PRODUCT_ITEM_TYPES } from 'constants/productTypes';
import { cookieBasketService } from 'services';
import { getCurrentCategoriesPathYM } from 'store/common/navigation/selectors';
import {
  getCrossSellActiveId,
  getCrossSellActiveItem,
  getCrossSellItemRequestIsBusy,
  getCrossSellProductsList,
  getCSAIIndex,
  getCrossSellLoadDetailsUrl,
  getCSPBadgesTitlesString,
  getCSPRating,
  getCrossSellCountToShowDesktop,
  getCrossSellCountToShowMobile,
} from './selectors';

import {
  CLEAR_CROSSSELL_ACTIVE_ID,
  SET_CROSSSELL_ACTIVE_ID,
  REQUEST_CROSSSELL_DETAILS,
  REQUEST_CROSSSELL_DETAILS_DONE,
  REQUEST_CROSSSELL_DETAILS_ERROR,
  REQUEST_OPS_TRACK_URL,
  REQUEST_CROSSSELL_TRACK_OPEN,
  REQUEST_CROSSSELL_TRACK_ACTIVATION,
  UPDATE_CROSSSELL_CATEGORY_LIST,
  SET_CROSSSELL_COUNT_TO_SHOW,
} from './constants';
import { getBasketData, getBasketUrl } from '../../common/basket/selectors';
import { getBasketData as getBasketDataAction, updateCartData } from 'store/common/basket/actions';
import { addBasketItem } from '../../common/basket/actions';
import { convertCrossSellDetailsData } from './dataConverter';
import { addProductsToNewBasket } from './helpers';
import {
  getABTestValueByStand,
  isUATStand,
} from 'store/common/ab/helpers';
import { SET_BASKET_DATA } from 'store/common/basket/constants';
import { cartApi } from '../../../api';
import {setQuantity} from "store/common/specialProjectHeader/cart";

/** success callback for `loadCrossSellDetails` */
export const loadCrossSellDetailsSuccess = ({ productId }, responseData) => ({
  type: REQUEST_CROSSSELL_DETAILS_DONE,
  productId,
  details: responseData,
});


/** error callback for `loadCrossSellDetails` */
export const loadCrossSellDetailsError = ({ productId }, { message }) => ({
  type: REQUEST_CROSSSELL_DETAILS_ERROR,
  productId,
  message,
});


/**
 * Function loads detailed data for crossSell popup
 */
export const loadCrossSellDetails = ({ productId }) => (
  (dispatch, getState) => {
    const state = getState();
    if (getCrossSellItemRequestIsBusy(state, { productId })) return;

    const data = {
      productId,
      isBasket: false,
      jsonResult: true,
    };
    dispatch({
      type: REQUEST_CROSSSELL_DETAILS,
      productId,
      data,
    });

    const token = getRequestVerificationToken(state);
    const crossSellDetailsUrl = getCrossSellLoadDetailsUrl(state);

    axios({
      method: 'POST',
      url: crossSellDetailsUrl,
      data,
      headers: {
        __RequestVerificationToken: token,
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(({ data: responseData }) => {
      // TODO: remove this hardcoded crutch, when SHOP-1140 is closed
      if (responseData.isSucceeded) {
        if (
          responseData.data.compareDetails &&
          responseData.data.compareDetails.compareUrl === '/shop/ShopComparison'
        ) {
          responseData.data.compareDetails.compareUrl = '/shop/comparison/';
        }
        dispatch(loadCrossSellDetailsSuccess(data, convertCrossSellDetailsData(responseData.data)));
      } else {
        dispatch(loadCrossSellDetailsError({
          message: responseData.errorMessage,
        }));
      }
    }).catch((err) => {
      dispatch(loadCrossSellDetailsError(data, { message: err }));
      throw err;
    });
  }
);

/**
 * Function sends OPS track info
 */
export const sendTrackInfo = ({ productId, activation }) => (
  (dispatch) => {
    dispatch({
      type: activation ? REQUEST_CROSSSELL_TRACK_ACTIVATION : REQUEST_CROSSSELL_TRACK_OPEN,
    });

    const ga = getCookie('_ga');

    const sendTrackUrl = REQUEST_OPS_TRACK_URL;

    const data = {
      productId,
      state: activation ? 'activation' : 'open',
      ga,
    };

    axios({
      method: 'post',
      url: sendTrackUrl,
      data: toUrlEncodedString(data),
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }
);

/**
 * method tracking clicks on RecentlyViewed,
 * if item is already added, moves to basket instead
 */
export const setCrossSellActiveId = ({
  productId,
  /** fields required by gtm */
  feedback,
  remains,
  contentPromotion,
  title, price, brand, position, discount,
}) => (dispatch, getState) => {
  const state = getState();
  const category = getCurrentCategoriesPathYM(state);
  const highLights = getCSPBadgesTitlesString(state, productId);
  /** preload data for popup for productid */
  dispatch(loadCrossSellDetails({ productId }));
  /** send track info for productid */
  dispatch(sendTrackInfo({ productId }));
  /** open popup with productId */
  dispatch({
    type: SET_CROSSSELL_ACTIVE_ID,
    productId,
  });

  pushEvent(EVENT_OPEN_ACCESSORY_POPUP, {
    list: positionGTMEnum.CONTENT_TAB_CROSS_SALE,
    brand,
    category,
    id: productId,
    name: title,
    position,
    price: (price || {}).value || 0,
    metric14: discount,
    metric15: (feedback || {}).average || null, // rating
    /**
     * У нет ни рейтинга, ни бэйджей, ни контент-промоушенов,
     * товары в статусах `предзаказ` и `нет в наличии` не отображаются
     */
    dimension15: highLights,
    dimension16: remains,
    dimension17: contentPromotion,
  });
};

/**
 * Opens CrossSell popup for item with polar offset
 * @param offset - offset from currently open item index, +1 opens next, -1 previous etc
 */
export const openCSAIOffsetItem = ({ offset }) =>
  (dispatch, getState) => {
    console.assert(typeof offset === 'number' && offset, 'Must be a positive or negative number');
    const state = getState();
    const list = getCrossSellProductsList(state);
    const targetIndex = getCSAIIndex(state) + offset;

    if (targetIndex >= 0 && targetIndex <= list.length - 1) {
      const { productId } = list[targetIndex];
      dispatch(setCrossSellActiveId({ productId }));
    } else {
      throw Error('Attempting to open item before first');
    }
  };


export const clearCrossSellActiveId = () => ({
  type: CLEAR_CROSSSELL_ACTIVE_ID,
});

/**
 * TODO: remove all params from here, only need productId
 * method for adding CrossSellProduct to basket,
 * if item is already added, moves to basket instead
 */
export const addToBasketCrossSell = (product, source, isRedirect = false) => (
  (dispatch, getState) => {
    const {
      isInBasket,
      title,
      price,
      brand,
      categoryId,
      /** fields required by gtm */
      // position,
      discount,
      remains,
      contentPromotion,
    } = product;

    const productId = product.productId || product.id;

    const state = getState();

    if (isInBasket) {
      return redirectToBasket();
    }


    dispatch(addToNewBasketCrossSell(productId, source, isRedirect, price));

    // ops track
    dispatch(sendTrackInfo({ productId, activation: true }));
    // ===
    // TODO reuse this for cross Sell;
    dispatch(addBasketItem({ productId: productId }));

    const rating = getCSPRating(state, productId);
    const highLights = getCSPBadgesTitlesString(state, productId);
    const category = getCurrentCategoriesPathYM(state);

    pushEvent(EVENT_ADD_ACCESSORY, {
      list: positionGTMEnum.CONTENT_TAB_CROSS_SALE,
      name: title,
      id: productId,
      price: price.value,
      brand,
      category,
      discount,
      rating, // metric15 prop
      highLights, // dimension15 prop
      contentPromotion, // dimension17 prop
      remains, // dimension16 prop
    });
  }
);

export const addToNewBasketCrossSell = (productId, source, isRedirect = false, price) =>
  async (dispatch, getState) => {
    const state = getState();
    const regionCode = getCurrentRegionCode(state);
    const isBasketRedirectEnabled = selectIsBasketRedirectEnabled(state);

    const isUAT = isUATStand();

    const abNewBasket = getABTestValueByStand(state);

    // if (!abNewBasket) return;

    const basketId = cookieBasketService.getBasketIdCookie();

    const newProduct = {
      itemType: PRODUCT_ITEM_TYPES.PRODUCT,
      id: productId,
      quantity: 1,
    };

    if (source) {
      newProduct.source = source;
    }

    dispatch({
      type: SET_COMMON_LOADING,
      payload: true,
    });

    if (basketId) {
      const data = await cartApi.basketMergeItems(basketId, [newProduct]);
      dispatch(setQuantity(data));
      dispatch(updateCartData(data?.items || []));

      dispatch({
        type: SET_COMMON_LOADING,
        payload: false,
      });

      if (isBasketRedirectEnabled) {
        redirectToBasket();
      }

      return data;
    }

    const data = await cartApi.basketCreateBasket(cartApi.helpers.createBasketData([newProduct], regionCode));
    dispatch(setQuantity(data));
    dispatch(updateCartData(data?.items || []));

    dispatch({
      type: SET_COMMON_LOADING,
      payload: false,
    });

    if (isBasketRedirectEnabled) {
      redirectToBasket();
    }

    if (data) {
      dispatch({
        type: SET_BASKET_DATA,
        payload: data?.items || [],
      });

      cookieBasketService.setBasketIdCookie(data.id);

      return data;
    }
  };

/**
 * automatic basket adder for cross sell item
 */
export const addCSAIToBasket = () => (
  (dispatch, getState) => {
    const state = getState();
    const CSAI = getCrossSellActiveItem(state);

    dispatch(addToBasketCrossSell(CSAI));
  }
);

/**
 * onLoad event for cross sell
 */
export const crossSellDOMLoaded = list => (
  (dispatch, getState) => {
    // GTM push when crossSale component appears in the viewport

    const nodeAppearCheck = (node) => {
      if (node) {
        const nodeRect = node.getBoundingClientRect();
        const nodeOffsetTop = nodeRect.top + window.pageYOffset;
        const windowScrollBottom = window.pageYOffset + document.documentElement.clientHeight - nodeRect.height;

        if (windowScrollBottom >= nodeOffsetTop) { return true; }
      }
      return false;
    };

    const crossSale = document.getElementById('crossSale');
    // ===
    const state = getState();
    const regionName = getCurrentRegionName(state);
    const federalRegionName = getCurrentFederalRegionName(state);
    const category = getCurrentCategoriesPathYM(state);
    // ===
    const crossSaleAppearListener = () => {
      if (nodeAppearCheck(crossSale)) {
        pushEvent(EVENT_VIEW_ACCESSORY, {
          list,
          regionName,
          federalRegionName,
          category,
        });
        window.removeEventListener('scroll', crossSaleAppearListener);
      }
    };

    window.addEventListener('scroll', crossSaleAppearListener);
  }
);

/**
 * onSwitchFrame event for cross sell
 */

export const crossSellSwitchFrame = (list, count, size) => (
  () => {
    const viewList = list || [];
    const viewCount = count || 0;
    const viewSize = size || 0;
    const viewFrameList = viewList.slice(viewCount, viewCount + viewSize);
    const category = getCurrentCategoriesPathYM(state);
    pushEvent(EVENT_VIEW_ACCESSORY, {
      viewFrameList,
      category,
    });
  }
);

/**
 * wrapper for toggleProductCompare,
 * CSAI stands for CrossSell Active Item
 */
export const toggleCSAICompare = () =>
  (dispatch, getState) => {
    const state = getState();
    const productId = getCrossSellActiveId(state);

    /** set compare into value opposite from current */
    dispatch(toggleCompareProduct({ productId }));
  };

/** crossSell in tab */

export const setActiveCrossSellCategory = slug =>
  (dispatch) => {
    dispatch({
      type: UPDATE_CROSSSELL_CATEGORY_LIST,
      payload: slug,
    });
  };

export const setCrossSellCountToShow = isMobile =>
  (dispatch, getState) => {
    const state = getState();
    const countToShowDesktop = getCrossSellCountToShowDesktop(state);
    const countToShowMobile = getCrossSellCountToShowMobile(state);

    const newCountToShowDesktop = isMobile ? countToShowDesktop : (countToShowDesktop + 3);
    const newCountToShowMobile = isMobile ? (countToShowMobile + 3) : countToShowDesktop;

    dispatch({
      type: SET_CROSSSELL_COUNT_TO_SHOW,
      payload: {
        countToShowDesktop: newCountToShowDesktop,
        countToShowMobile: newCountToShowMobile,
      },
    });
  };
